import type React from 'react';

const clampValue = function (value: number, min: number, max: number) {
    return Math.min(Math.max(value, min), max);
};

export const runOnRefExists = (ref: React.RefObject<any>, funcToRun: () => any, attempts = 10, interval = 100) => {
    // Правка для 'Uncontrolled Resource Consumption'
    const safeAttempts = clampValue(attempts, 1, 100);
    const safeInterval = clampValue(interval, 1, 5000);

    let attemptsLeft = safeAttempts;

    const checkAndRun = () => {
        attemptsLeft -= 1;

        if (ref.current) {
            funcToRun();
        } else if (attemptsLeft) {
            setTimeout(checkAndRun, safeInterval);
        }
    };

    checkAndRun();
};

export const runOn = (funcToCheck: () => any, funcToRun: () => any, attempts = 10, interval = 1) => {
    // Правка для 'Uncontrolled Resource Consumption'
    const safeAttempts = clampValue(attempts, 1, 100);
    const safeInterval = clampValue(interval, 1, 5000);

    let attemptsLeft = safeAttempts;

    const checkAndRun = () => {
        attemptsLeft -= 1;

        if (funcToCheck()) {
            funcToRun();
        } else if (attemptsLeft) {
            setTimeout(checkAndRun, safeInterval);
        } else {
            funcToRun();
        }
    };

    checkAndRun();
};
